import { useCallback } from 'react';
import { URLSearchParamsInit, useSearchParams } from 'react-router-dom';
import { Store } from 'antd/es/form/interface';
import { reduce } from 'lodash';

export const useTableSearchParams = (values?: { tableFormParams?: string[], defaultPage?: number, defaultSize?: number }) => {
  const [searchParams, setParams] = useSearchParams();

  const page = searchParams.get('page');
  const size = searchParams.get('size');
  const sort = searchParams.get('sort');

  const sortField = sort && sort.split(',')[0];
  const sortOrder = sort && sort.split(',')[1];
  const sortOrderType = sortOrder && (sortOrder === 'desc' ? 'descend' : 'ascend');

  const defaultTableParams = {
    sorter: { field: sortField, order: sortOrderType },
    current: Number(page) || values?.defaultPage || 1,
    pageSize: Number(size) || values?.defaultSize || 50,
  };

  const formInitialValues = reduce<string, Store>(values?.tableFormParams, (acc, key) => {
    const param = searchParams.get(key);

    acc[key] = param;

    return acc;
  }, {});

  const setSearchParams = useCallback((params: URLSearchParamsInit) => {
    setParams(params, { replace: true });
  }, []);

  return {
    setSearchParams,
    formInitialValues,
    defaultTableParams,
  };
};
